// What the platform admin Add user panel shows after /api/admin-create-user
// (hotfix 02/11/2026). The panel used to show "User created and welcome email
// sent" for every success, including the one that reset another firm's login.
// It now shows exactly the message the route returned, and the tone follows
// the route's outcome code; a reply with no message is said to be unreadable,
// never shown as a success.

export const ADMIN_USER_OUTCOMES = {
  created: 'ok',                    // new login, membership saved, welcome email sent
  created_email_not_sent: 'warn',   // new login, membership saved, welcome email not sent
  created_link_failed: 'error',     // new login, membership not saved, no email
  added: 'ok',                      // existing login with no firm, membership added, no password
  add_failed: 'error',              // existing login with no firm, membership not saved
  refused_existing_firm: 'error',   // existing login already in a firm
  refused_lookup_failed: 'error',   // the login lookup could not be completed
  refused_firm_not_found: 'error',
  create_failed: 'error',
};

export function adminUserPanelMessage(result, httpStatus) {
  const r = result && typeof result === 'object' ? result : {};
  const text = typeof r.message === 'string' && r.message ? r.message : (typeof r.error === 'string' && r.error ? r.error : '');
  if (!text) return { tone: 'error', text: `The server reply could not be read (status ${httpStatus || 'unknown'}). Check the firm's users before trying again.` };
  const tone = ADMIN_USER_OUTCOMES[r.outcome] || (r.success === true ? 'warn' : 'error');
  return { tone, text, outcome: r.outcome || null };
}
